import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
}

const TopTenIcon: React.FC<CustomIconProps> = () => (
  <svg
    width='17'
    height='21'
    viewBox='0 0 17 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0.492188 1.75304V0.700041H5.15419V1.75304H3.42619V7.00004H2.22019V1.75304H0.492188Z'
      fill='white'
    />
    <path
      d='M8.27986 0.592041C9.95386 0.592041 11.0249 1.90604 11.0249 3.85004C11.0249 5.79404 9.95386 7.10804 8.27986 7.10804C6.59686 7.10804 5.52586 5.79404 5.52586 3.85004C5.52586 1.90604 6.59686 0.592041 8.27986 0.592041ZM8.27986 1.63604C7.31686 1.63604 6.78586 2.51804 6.78586 3.85004C6.78586 5.18204 7.31686 6.06404 8.27986 6.06404C9.23386 6.06404 9.76486 5.17304 9.76486 3.85004C9.76486 2.52704 9.23386 1.63604 8.27986 1.63604Z'
      fill='white'
    />
    <path
      d='M16.2935 2.79704C16.2935 3.86804 15.5825 4.91204 14.0255 4.91204H13.1345V7.00004H11.9285V0.700041H14.0255C15.5825 0.700041 16.2935 1.73504 16.2935 2.79704ZM15.0245 2.79704C15.0245 2.25704 14.7095 1.75304 13.9355 1.75304H13.1345V3.85904H13.9355C14.7095 3.85904 15.0245 3.34604 15.0245 2.79704Z'
      fill='white'
    />
    <path
      d='M6.2423 20H4.1493V13.11L2.6413 13.825V11.836L4.7603 10.9H6.2423V20Z'
      fill='white'
    />
    <path
      d='M10.7062 10.744C12.8902 10.744 14.1902 12.473 14.1902 15.45C14.1902 18.427 12.8902 20.156 10.7062 20.156C8.50918 20.156 7.22218 18.427 7.22218 15.45C7.22218 12.473 8.50918 10.744 10.7062 10.744ZM10.7062 12.512C9.71818 12.512 9.41918 13.812 9.41918 15.45C9.41918 17.088 9.71818 18.388 10.7062 18.388C11.6812 18.388 11.9932 17.153 11.9932 15.45C11.9932 13.747 11.6812 12.512 10.7062 12.512Z'
      fill='white'
    />
  </svg>
);

export default TopTenIcon;
